export interface OptimizeState {
  experiments: {
    [name: string]: {
      value: string;
    };
  };
}

export const initialState: OptimizeState = {
  experiments: {}
};
